import React, {Component} from "react";
import './ListeEtudiants.css'

class ListeEtudiants extends Component {
	state = {
	    id: "",
		etudiants: [{"id":19,"numero_etudiant":"MI-19-2021-00008","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IA","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-16T13:44:26.624Z"},{"id":20,"numero_etudiant":"MI-19-2021-00009","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الثالثة","specialite_generale":"إعلام آلي","specialite_speciale":"ISIL","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-05T11:29:10.222Z"},{"id":21,"numero_etudiant":"MI-19-2021-00010","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IA","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-07T20:37:37.406Z"},{"id":35,"numero_etudiant":"MI-18-2021-00035","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":3333,"annee_bac":"2018","branche_bac":"الرياضيات","moyenne_bac":12.22,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"إعلام آلي","specialite_speciale":"SI","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-07T11:05:42.098Z","updatedAt":"2021-11-07T20:36:50.222Z"},{"id":49,"numero_etudiant":"MI-21-2021-00049","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":765765,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":18,"montion_bac":"ممتاز","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":null,"section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الإعلام الآلي","universite_origine":"جامعة هواري","createdAt":"2021-11-11T18:26:03.165Z","updatedAt":"2021-11-11T18:26:03.165Z"},{"id":50,"numero_etudiant":"MI-21-2021-00050","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":765765,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":null,"section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الإعلام الآلي","universite_origine":"","createdAt":"2021-11-11T18:26:13.116Z","updatedAt":"2021-11-11T18:26:13.116Z"},{"id":52,"numero_etudiant":"MI-21-2021-00052","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IDO","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"رياضيات وإعلام آلي","classe_origine":"الإعلام الآلي","universite_origine":"جامعة هواري","createdAt":"2021-11-11T18:56:00.125Z","updatedAt":"2021-11-16T19:51:09.424Z"},{"id":53,"numero_etudiant":"MI-21-2021-00053","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"SIGL","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الرياضيات","universite_origine":"","createdAt":"2021-11-11T18:56:19.959Z","updatedAt":"2021-11-11T18:56:19.959Z"},{"id":54,"numero_etudiant":"MI-21-2021-00054","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"SIGL","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الرياضيات","universite_origine":"جامعة الجلفة","createdAt":"2021-11-11T18:56:50.823Z","updatedAt":"2021-11-11T18:56:50.823Z"},{"id":55,"numero_etudiant":"MI-21-2021-00055","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":222222,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"F","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-14T19:16:02.858Z","updatedAt":"2021-11-14T19:21:40.842Z"},{"id":56,"numero_etudiant":"MI-21-2021-00056","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":223223,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"D","groupe":6,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T09:12:00.612Z","updatedAt":"2021-11-16T09:12:00.612Z"},{"id":57,"numero_etudiant":"MI-21-2021-00057","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":2333,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":18,"montion_bac":"ممتاز","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"D","groupe":6,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T11:29:48.595Z","updatedAt":"2021-11-16T11:29:48.595Z"},{"id":58,"numero_etudiant":"MI-21-2021-00058","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":4567,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":13,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T12:11:43.776Z","updatedAt":"2021-11-16T12:11:43.776Z"},{"id":59,"numero_etudiant":"MI-21-2021-00059","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":3,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T13:46:51.396Z","updatedAt":"2021-11-16T13:46:51.396Z"},{"id":60,"numero_etudiant":"MI-21-2021-00060","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":222,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T13:48:30.079Z","updatedAt":"2021-11-16T13:48:30.079Z"}],
        etudiants_filtre: [],
        cycle: "",
        specialite_generale: "",
        annee_actuelle: "",
        specialite_speciale: "",
        section: "",
        groupe: ""
	}

    hideModal = () => {
        document.getElementById('id01').style.display='none'
    }

    showModal = () => {
        let modal = document.getElementById('id01');
        modal.style.display = "block";
    }

    imprimer = () => {
        let tt = document.getElementsByClassName('alert')[0]
        tt.innerHTML  = "لا توجد طابعة متصلة بالحاسوب"
        tt.style.display  = "block"
        setTimeout(function(){
            tt.style.display = "none";
        }, 3000);
    }

    clickRow = (e) => {
        let id = e.currentTarget.id
        this.setState({id: id})
        let className = e.currentTarget.className.split(' ')
        if(className[0] === 'edit') {
            let url = "/modifier/" + id
            this.props.history.push(url)
        } else {
            this.showModal()
        }
    }

    supprimer = () => {
        this.hideModal()

        let tt = document.getElementsByClassName('alert-success')[0]
        tt.innerHTML  = "تم حذف الطالب وإدراجه في الأرشيف"
        tt.style.display  = "block"
        setTimeout(function(){
            tt.style.display = "none";
        }, 3000);
    }

	filtre_table = (e) => {
        let cycle = document.getElementsByName('cycle')[0].value
        let specialite_generale = document.getElementsByName('specialite_generale')[0].value
        let annee_actuelle = document.getElementsByName('annee_actuelle')[0].value
        let specialite_speciale = document.getElementsByName('specialite_speciale')[0].value
        let section = document.getElementsByName('section')[0].value
        let groupe = document.getElementsByName('groupe')[0].value
        let etudiants = []

        this.setState({etudiants_filtre: this.state.etudiants})

        if(cycle === "") {
            this.setState({etudiants_filtre: this.state.etudiants})
        } else {
            for(let i=0; i<this.state.etudiants.length; i++) {
                if(this.state.etudiants[i].cycle === cycle) {
                    etudiants.push(this.state.etudiants[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }

        etudiants = []
        if(specialite_generale === "") {

        } else {
            for(let i=0; i<this.state.etudiants_filtre.length; i++) {
                if(this.state.etudiants_filtre[i].specialite_generale === specialite_generale) {
                    etudiants.push(this.state.etudiants_filtre[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }

        etudiants = []
        if(annee_actuelle === "") {

        } else {
            for(let i=0; i<this.state.etudiants_filtre.length; i++) {
                if(this.state.etudiants_filtre[i].annee_actuelle === annee_actuelle) {
                    etudiants.push(this.state.etudiants_filtre[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }

        etudiants = []
        if(specialite_speciale === "") {

        } else {
            for(let i=0; i<this.state.etudiants_filtre.length; i++) {
                if(this.state.etudiants_filtre[i].specialite_speciale === specialite_speciale) {
                    etudiants.push(this.state.etudiants_filtre[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }

        etudiants = []
        if(section === "") {

        } else {
            for(let i=0; i<this.state.etudiants_filtre.length; i++) {
                if(this.state.etudiants_filtre[i].section === section) {
                    etudiants.push(this.state.etudiants_filtre[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }

        etudiants = []
        if(groupe === "") {

        } else {
            for(let i=0; i<this.state.etudiants_filtre.length; i++) {
                if(this.state.etudiants_filtre[i].groupe.toString() === groupe.toString()) {
                    etudiants.push(this.state.etudiants_filtre[i])
                }
            }
            this.setState({etudiants_filtre: etudiants})
        }
    }


    cycle_change = (e) => {
        this.filtre_table()
    }
    specialite_generale_change = (e) => {
        this.filtre_table()

    }
    annee_actuelle_change = (e) => {
        this.filtre_table()
    }
    specialite_speciale_change = (e) => {
        this.filtre_table()
    }
    section_change = (e) => {
        this.filtre_table()
    }
    groupe_change = (e) => {
        this.filtre_table()
    }

    reset_filtre = () => {
        this.setState({
            etudiants_filtre: this.state.etudiants,
        })
        document.getElementsByName('cycle')[0].value = ""
        document.getElementsByName('specialite_generale')[0].value = ""
        document.getElementsByName('annee_actuelle')[0].value = ""
        document.getElementsByName('specialite_speciale')[0].value = ""
        document.getElementsByName('section')[0].value = ""
        document.getElementsByName('groupe')[0].value = ""
    }

    componentDidMount() {
        this.setState({
            etudiants_filtre: this.state.etudiants,
        })
	}

    render() {
        return(
            <div className="content-liste-etudiants">
               <h2>قائمة الطلبة المسجلين في الكلية</h2>
                <div className="filtre">
                    <label>فلترة الجدول حسب :</label>
                    <select name="cycle" onChange={this.cycle_change} className="field-divided">
                        <option value="">اختر الطور</option>
                        <option value="ليسانس">ليسانس</option>
                        <option value="ماستر">ماستر</option>
                        <option value="دكتورا">دكتورا</option>
                    </select>
                    <select name="annee_actuelle" onChange={this.annee_actuelle_change} className="field-divided">
                        <option value="">اختر السنة</option>
                        <option value="السنة الأولى">السنة الأولى</option>
                        <option value="السنة الثانية">السنة الثانية</option>
                        <option value="السنة الثالثة">السنة الثالثة</option>
                    </select>
                    <select name="specialite_generale" onChange={this.specialite_generale_change} className="field-divided">
                        <option value="">اختر الشعبة</option>
                        <option value="جذع مشترك رياضيات وإعلام آلي">جذع مشترك رياضيات وإعلام آلي</option>
                        <option value="إعلام آلي">إعلام آلي</option>
                    </select>
                    <select name="specialite_speciale" onChange={this.specialite_speciale_change} className="field-divided">
                        <option value="">إختر الإختصاص</option>
                        <option value="SI">SI</option>
                        <option value="ISIL">ISIL</option>
                        <option value="IDO">IDO</option>
                        <option value="AI">AI</option>
                    </select>
                    <select name="section" onChange={this.section_change} className="field-divided">
                        <option value="">اختر المجموعة</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                        <option value="F">F</option>
                    </select>
                    <select name="groupe" onChange={this.groupe_change} className="field-divided">
                        <option value="">الفوج</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                    </select>
                    <input type="submit" value="طباعة" className="imprimer_liste" onClick={this.imprimer} />
                    <input type="submit" value="حذف الفلترة" className="reset_filtre" onClick={this.reset_filtre} />
                </div>
               <div>
                <table>
                    <thead>
                        <tr>
                            <th>رقم الطالب</th>
                            <th>اللقب</th>
                            <th>الإسم</th>
                            <th>الطور</th>
                            <th>السنة</th>
                            <th>الشعبة</th>
                            <th>الإختصاص</th>
                            <th>المجموعة</th>
                            <th>الفوج</th>
                            <th>العملية</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.etudiants_filtre.reverse().map(etudiant =>
                        <tr key={etudiant.id}>
                            <td>{etudiant.numero_etudiant}</td>
                            <td>{etudiant.nom_ar}</td>
                            <td>{etudiant.prenom_ar}</td>
                            <td>{etudiant.cycle}</td>
                            <td>{etudiant.annee_actuelle}</td>
                            <td>{etudiant.specialite_generale}</td>
                            <td>{etudiant.specialite_speciale}</td>
                            <td>{etudiant.section}</td>
                            <td>{etudiant.groupe}</td>
                            <td><i id={etudiant.id} onClick={this.clickRow} className="edit fa fa-edit fa-1x"></i><span style={{paddingLeft: "5px"}}></span><i id={etudiant.id} onClick={this.clickRow} className="delete fa fa-trash fa-1x"></i></td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
                <div id="id01" className="modal1">
                    <div className="container modal-content">

                        <h2>هل تريد حذف الطالب ؟</h2>

                        <div className="clearfix">
                            <button type="button" onClick={this.hideModal}
                                    className="cancelbtn">لا
                            </button>
                            <button type="button" onClick={this.supprimer}
                                    className="confirmbtn">نعم
                            </button>
                        </div>
                    </div>
                </div>
                <div className="alert-section">
                    <div className="alert" style={{display: "none", position: "absolute", alignItems: "center", bottom: 70, minWidth: "300px"}}>

                    </div>
                    <div className="alert-success" style={{display: "none", position: "absolute", bottom: 70, minWidth: "300px"}}>

                    </div>
                </div>
            </div>

        )
    }
}

export default ListeEtudiants